module.exports = __webpack_public_path__ + "static/khoshzabaan-cover-1d27c6522fe98e9d4455b74e1733c89a.jpg";